import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import SortableHeader from '../../components/tables/SortableHeader';
import { Shapes } from '../../models/entities';

import { loadCards } from '../../actions/creditCards';
import { updateCardsSorting } from '../../actions/sorting';

class CardSortableHeader extends PureComponent {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(newSorting) {
    const {
      updateCardsSorting: updateSorting,
      loadCards: refreshCards,
    } = this.props;

    updateSorting(newSorting);
    refreshCards().catch((error) => toast.error(error.message));
  }

  render() {
    const { sorting, fieldName, children } = this.props;
    return (
      <SortableHeader
        fieldName={fieldName}
        sorting={sorting}
        onClick={this.onClick}
      >
        {children}
      </SortableHeader>
    );
  }
}

CardSortableHeader.propTypes = {
  fieldName: PropTypes.string.isRequired,
  updateCardsSorting: PropTypes.func.isRequired,
  loadCards: PropTypes.func.isRequired,
  sorting: Shapes.SORTING.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

CardSortableHeader.defaultProps = {
  children: undefined,
};

const mapStateToProps = (state) => {
  const { sorting: { cards: sorting } } = state;
  return {
    sorting,
  };
};

export default connect(mapStateToProps, {
  updateCardsSorting, loadCards,
})(CardSortableHeader);
